import axios from "axios";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { xCheckSumIdGernator } from "../../helper/helper";
import { toast, ToastContainer } from "react-toastify";
import EmailVerified from "./EmailStatus/EmailVerified";
import EmailWarning from "./EmailStatus/EmailWarning";
import EmailRejected from "./EmailStatus/EmailRejected";
import Swal from "sweetalert2";

export default function EmailVerification() {
  const [Page, setPage] = useState(3);
  const location = useLocation();
  // console.log(location);

  let split = location.search.split("=");
  split = split[1];

  // console.log({ split });

  const verifyEmail = async () => {
    try {
      const xCheckSumValues = xCheckSumIdGernator(split);

      const res = await axios.post(
        `${process.env.REACT_APP_COMMON_API}/auth/v1/email/verification/`,
        {
          emailToken: split,
          requistId: xCheckSumValues.generator,
          isDebug: true,
        },
        {
          headers: {
            "X-CHECKSUM-ID": xCheckSumValues.allValuesHashed,
          },
        }
      );
      if (res.data.statusDescription.statusCode === 200) {
        setTimeout(() => {
          // toast.success("Logged In Successfully", {
          //   theme: "colored",
          // });
          Swal.fire({
            icon: "success",
            // title: "Oops...",
            text: "Logged In Successfully",
            // footer: '<a href="">Why do I have this issue?</a>'
          });
        }, 200);
        await setPage(0);
      } else {
        setTimeout(() => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: res.data.statusDescription.description,
            // footer: '<a href="">Why do I have this issue?</a>'
          });
        }, 200);
        await setPage(1);
      }
    } catch (error) {
      // console.log(error);
      setTimeout(() => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong",
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }, 200);
      await setPage(2);
    }
  };

  useEffect(() => {
    verifyEmail();
  }, []);

  if (Page === 0) {
    return <EmailVerified />;
  } else if (Page === 1) {
    return <EmailRejected />;
  } else if (Page === 2) {
    return <EmailWarning />;
  } else {
    return (
      <>
        <main className="main-content  mt-0">
          <h1>Email Verification Under Process</h1>
          <ToastContainer autclose={100} />
        </main>
      </>
    );
  }
}
